import { render, staticRenderFns } from "./DoctorsTreatingQueue.vue?vue&type=template&id=9e382f30&scoped=true"
import script from "./DoctorsTreatingQueue.vue?vue&type=script&lang=js"
export * from "./DoctorsTreatingQueue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e382f30",
  null
  
)

export default component.exports